import React from 'react'
import { Trans } from 'next-i18next'
import styled from 'styled-components'

import structure from '@/structure'
import { breakpoints, colors } from '@/styles'
import { ExclamationOctagon } from '@/components/icons'

const Wrapper = styled.div`
  margin: 24px auto 0;
  border-radius: 6px;
  border: 1px solid ${colors.red88};
  width: 95%;
  background: ${colors.red96};
  max-width: ${structure.page.width}px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px;

  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    margin: 0;
    border-radius: 0;
    border: none;
    width: 100%;
  }
`

const Banner = () => {
  return (
    <Wrapper>
      <ExclamationOctagon width={20} />
      <span>
        <Trans i18nKey="listing:b.listing_details.rented.banner.text">
          This listing has been marked as rented and is no longer accepting
          applications.
        </Trans>
      </span>
    </Wrapper>
  )
}

export default Banner
